module.exports = __webpack_public_path__ + "static/media/60.8186a3c1.png";